import { PaymentProcessEnum } from 'libs/shared/models/payment-method/payment-method.models'

export interface PaymentMethodsEntity {
  uuid: string
  auction: string
  display_name: string
  payment_process: PaymentProcessEnum
  flat_fee: string
  percentage_fee: string
  service_fee_label: string
  optional_fee: PaymentMethodFeeTypeEnum
  guest_payment_method: boolean
  volunteer_payment_method: boolean
  apply_fee_to_final_charge: boolean
  created: string
  updated: string
}

export enum FeeTypeEnum {
  Percentage = 'percentage',
  Flat = 'flat',
  Both = 'both',
  None = 'none',
}

export enum PaymentMethodFeeTypeEnum {
  DonationOptional = 'donation_optional',
  AllOptional = 'all_optional',
  Mandatory = 'mandatory',
}

export enum PaymentGatewayEnum {
  None = 'none',
  GalaBid = 'galabid',
  Stripe = 'stripe',
}

export const DEFAULT_SERVICE_FEE_LABEL = 'service fee'
